import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
// import ProfileIntro from './ProfileIntro';
import { Card, CardBody } from 'react-bootstrap';
// import associations from 'data/associations';
// import Associations from 'components/pages/asscociations/Associations';
// import people from 'data/people';
// import activities from 'data/activities';
// import Followers from './Followers';
// import ActivityLog from './ActivityLog';
// import Events from './Events';
// import events from 'data/events/events';
// import Photos from './Photos';
import { useParams } from 'react-router-dom';
import TabOne from './TabOne';
import TabTwo from './TabTwo';
import TabThree from './TabThree';
import TabFour from './TabFour';

const Profile = () => {
  const { nurseId, defaultActiveKey } = useParams();
  // console.log(nurseId);

  return (
    <>
      <Card>
        <CardBody>
          <Tabs
            defaultActiveKey={defaultActiveKey}
            id="uncontrolled-tab-example"
          >
            <Tab eventKey="profile" title="Profile" className="p-1">
              <TabOne nurseId={nurseId} />
            </Tab>

            <Tab eventKey="documents" title="Documents" className="p-1">
              <TabTwo nurseId={nurseId} />
            </Tab>

            <Tab eventKey="references" title="References" className="p-1">
              <TabThree nurseId={nurseId} />
            </Tab>

            <Tab eventKey="timeOff" title="Time Off" className="p-1">
              <TabFour nurseId={nurseId} />
            </Tab>
          </Tabs>
        </CardBody>
      </Card>
    </>
  );
};

export default Profile;
